(() => {
  const allowedPartnershipTypes = new Set([
    'Distributor Partnership',
    'Wholesale Purchase',
    'Online Seller Program',
    'Not sure yet',
  ]);

  const queryAliases = new Map([
    ['distributor', 'Distributor Partnership'],
    ['wholesale', 'Wholesale Purchase'],
    ['online', 'Online Seller Program'],
  ]);

  function setPartnershipType(page, value) {
    if (!allowedPartnershipTypes.has(value)) return;

    const select = page.querySelector('[data-partnership-select]');
    if (!select || !Array.from(select.options).some((option) => option.value === value)) return;

    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function initializePartnerPage(page) {
    if (page.dataset.ybPartnerPageInitialized === 'true') return;
    page.dataset.ybPartnerPageInitialized = 'true';

    page.querySelectorAll('[data-partnership-type]').forEach((link) => {
      link.addEventListener('click', () => setPartnershipType(page, link.dataset.partnershipType));
    });

    const parameters = new URLSearchParams(window.location.search);
    const queryValue = parameters.get('partnership') || parameters.get('cooperation');
    const selectedValue = queryAliases.get(queryValue) || queryValue;
    if (selectedValue) setPartnershipType(page, selectedValue);

    const status = page.querySelector('#YBPartnerFormStatus');
    if (status) status.focus({ preventScroll: false });
  }

  function initializeAllPartnerPages(root = document) {
    root.querySelectorAll('[data-yb-partner-page]').forEach(initializePartnerPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllPartnerPages(), { once: true });
  } else {
    initializeAllPartnerPages();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllPartnerPages(event.target));
})();
